export default __webpack_public_path__ + "static/media/logo.eadc4664.svg";